var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvalanche = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 5h26v30H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.566 0C10.103 0 0 10.103 0 22.566 0 35.028 10.103 45.13 22.566 45.13c12.462 0 22.565-10.103 22.565-22.566C45.131 10.104 35.028 0 22.565 0Zm-1.92 28.955-.015.027c-.5.876-.754 1.32-1.105 1.654a3.29 3.29 0 0 1-1.347.781c-.461.127-.976.127-2.008.127h-4.38c-.92 0-1.376 0-1.651-.178a1.112 1.112 0 0 1-.505-.871c-.017-.327.21-.727.666-1.525L21.114 9.913c.461-.81.693-1.215.985-1.364a1.116 1.116 0 0 1 1.01 0c.293.149.528.554.986 1.364l2.223 3.88.012.019c.498.868.75 1.307.859 1.77a3.294 3.294 0 0 1 0 1.543c-.11.466-.361.91-.866 1.79l-5.68 10.04h.002Zm14.528 2.406c-.278.183-.741.183-1.669.183H27.23c-.924 0-1.39 0-1.664-.178a1.124 1.124 0 0 1-.505-.876c-.017-.325.213-.72.671-1.513l.01-.02 3.133-5.377c.46-.792.693-1.185.98-1.336a1.1 1.1 0 0 1 1.003 0c.286.146.51.522.952 1.27l.036.062 3.143 5.377c.015.027.032.051.046.078.437.751.659 1.134.642 1.452-.017.353-.205.68-.505.875l.002.003Z",
    fill: "#E84142"
  })));
};
export default SvgAvalanche;